module.exports = __webpack_public_path__ + "static/media/logo.7c1a7308.png";